import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "free-trial"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Team Plan", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppIcon = _resolveComponent("AppIcon")!

  return (_ctx.onFreeTrial && _ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", null, [
          _createTextVNode(" You have " + _toDisplayString(_ctx.daysLeftInFreeTrial()) + " days remaining in your free trial of the premium ", 1),
          _createVNode(_component_router_link, { to: "/settings#plans" }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_AppIcon, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isVisible = false)),
          name: "close"
        })
      ]))
    : _createCommentVNode("", true)
}